module.exports = __webpack_public_path__ + "app/assets/images/out-route-icon-small-hover.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/out-route-icon-small-hover.png
// module id = 879
// module chunks = 7